<template>
    <QrWrapper v-if="user">
        <QrHeader :text="trans('dashboard.hello-:name', { name: user.name })" trans="dashboard.hello-:name"/>
        <QrSubHeader :text="trans('dashboard.administrate-or-create-qr-codes')" trans="dashboard.administrate-or-create-qr-codes" class="mb-4"/>

        <div class="space-y-4">
            <QrCode v-for="qrCode in orderedCodes" :key="qrCode.id" :qrCode="qrCode"/>
            <QrCode v-for="qrCode in unfinishedCodes" :key="qrCode.id" :qrCode="qrCode"/>
        </div>

        <QrButton
            to="/create/product"
            icon-right="plus"
            :text="trans('code.create-qr-code')" trans="code.create-qr-code"
            class="mt-4"
            @click="createNewQrCode"
        />
    </QrWrapper>
</template>

<script setup>
import { useQrCodesStore} from "@/store/qrCodes";
import { trans } from "@/libs/helper.js";
import { storeToRefs } from "pinia";
import { useUserStore } from "@/store/user";
import TopMenu from "@/components/TopMenu.vue";
import QrCode from "@/components/qr-codes/QrCode.vue";
import QrButton from "@/components/application-ui/elements/QrButton.vue";
import QrWrapper from "@/components/application-ui/panels/QrWrapper.vue";
import {computed, onMounted} from "vue";
import QrHeader from "@/components/application-ui/content/QrHeader.vue";
import QrSubHeader from "@/components/application-ui/content/QrSubHeader.vue";
import {useRouter} from "vue-router";

const router = useRouter();
const userStore = useUserStore();
const qrCodeStore = useQrCodesStore();

const { qrCodes } = storeToRefs(qrCodeStore);
const { user } = storeToRefs(userStore);

const createNewQrCode = () => {
    qrCodeStore.resetNewQrCode();
    router.push({ name: 'new-qr-code' });
};

const orderedCodes = computed(() => qrCodes.value.filter(code => code.order));
const unfinishedCodes = computed(() => qrCodes.value.filter(code => ! code.order));

onMounted(() => qrCodeStore.fetchAll());

</script>
